import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { CLAIMS_INFO, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { AuthSevices } from 'libs/api/src/lib/auth.service';
import { TENANTSINTERFACE } from 'libs/models/src/lib/tenant';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthguardService implements CanActivate {
  constructor(private authservice: AuthSevices, private router: Router, private store: Store) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    let selectedTenant:any;
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      selectedTenant=tenant.selected_tenant;
    });
    
    if (this.authservice.isLoginedIn) {
      return this.store.select(CLAIMS_INFO).pipe(switchMap((claimsData: any) => {
        if (route?.data?.claim && !(String(claimsData.role).toLowerCase()==="admin")) {
          if (claimsData[route.data.claim] != undefined && claimsData[route.data.claim] == "true") {
            if (route?.data?.tenant && selectedTenant?.status && (selectedTenant?.status.toLowerCase() == 'active' || selectedTenant?.status.toLowerCase() == 'presales')) {
              return of(true)
            }
            else if (selectedTenant && selectedTenant?.status.toLowerCase() == 'inactive') {
              this.router.navigate(['/tenant-not-found']);
              return of(false)  
            }
            else {
              return of(true)
            }
          } else {
            if (
              selectedTenant?.status &&
              (selectedTenant?.status.toLowerCase() == 'active' || selectedTenant?.status.toLowerCase() == 'presales')
            ) {
              return of(true);
            } else {
              this.router.navigate(['/tenant-not-found'], {
                queryParams: { returnUrl: state.url },
              });
              return of(false);
            }
            //return of(true)
          }
        } else {
          if (selectedTenant && selectedTenant?.status.toLowerCase() == 'inactive') {
            this.router.navigate(['/tenant-not-found']);
            return of(false)  
          }
          else{
            return of(true);
          }
        }
      }));
    } else {
      let returnUrl = state.url.includes('?')
        ? state.url.split('?')[0]
        : state.url;
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
      return of(false);
    }
  }
}
